import { isNil, isEmpty } from 'lodash/lang';
import getTimeString from '@utils/date/get-time-string';
import getAvatar from '@utils/user/get-avatar';

/**
 * Handy object to be used on the messages view.
 *
 * @param {Object} provider
 * @param {Array} overview
 * @return {Array} The processed object to use
 */
export default function getPreviewsData(provider, overview) {
  if (isNil(provider)) {
    return [];
  }

  if (isEmpty(overview)) {
    return [createPreviewFromProvider(provider)];
  }

  const isNewProvider = isNil(overview.find((preview) => preview.user.uuid === provider.uuid));
  const previews = overview.map((preview) => getPreviewData(preview));

  if (isNewProvider) {
    return [createPreviewFromProvider(provider)].concat(previews);
  }

  return previews;
}

/**
 * Gets the preview data
 *
 * @param {Object} preview
 * @returns {Object}
 */
function getPreviewData(preview) {
  return {
    uuid: preview.user.uuid,
    from: preview.user.full_name,
    avatar: getAvatar(preview.user),
    unread: parseInt(preview.unread_messages, 10) > 0,
    at: isNil(preview.last_message) ? '' : getTimeString(preview.last_message.created_at),
    content: isNil(preview.last_message) ? '' : preview.last_message.message,
  };
}


/**
 * Gets a new preview data from a provider
 *
 * @param {Object} provider
 * @returns {Object}
 */
function createPreviewFromProvider(provider) {
  const preview = {
    user: provider,
    unread_messages: 0,
  };

  return getPreviewData(preview);
}
